import React from 'react';

import * as classes from './InactiveScoringGridContainer.module.css';

const InactiveScoringGridContainer = ({
    ...props
}) => {

    return (
        <div className={classes.InactiveScoringGridContainer}>
            <div>
                <p><i className={`fa fa-info-circle ${classes.Icon}`} aria-hidden="true" /> Attention!</p>
                <p>Please select an Equipment Type or System from the dropdown list above to load the data</p>
            </div>
        </div>
    );
};

export default InactiveScoringGridContainer;
